jQuery(document).ready(function($) {
  // on load, hide everything
  $('[data-js="service-group"]').each(function() {
    $(this).addClass('is-inactive');
  });

  // on click
  $('[data-js="service-group"] button').on('click', function() {
    toggleContent(this);
  });

  // toggle content
  function toggleContent(element) {
    var isExpanded = $(element).attr('aria-expanded');
    var content = $(element).next('.c-servicesGroup__list');
    var isActive = $(element).parent().attr('data-js');

    // hide everything
    $('[data-js="' + isActive + '"]').each(function() {
      $(this).children('button').attr('aria-expanded', 'false');
      $(this).addClass('is-inactive');
      $(this).removeClass('is-active');
    });

    // show clicked
    $(element).attr('aria-expanded', 'true');
    content.parent().removeClass('is-inactive');
    content.parent().addClass('is-active');


    if(isExpanded == 'false') {
      $(element).attr('aria-expanded', 'true');
      content.parent().removeClass('is-inactive');
      content.parent().addClass('is-active');
      // content.toggle('400');
    }
    if(isExpanded == 'true') {
      $(element).attr('aria-expanded', 'false');
      content.parent().addClass('is-inactive');
      content.parent().removeClass('is-active');
      // content.toggle('400');
    }
  }

}, jQuery);
